import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserInfo } from '../models/user/userInfo';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private rolesSource = new BehaviorSubject<UserInfo | null>(null);
  userRoles = this.rolesSource.asObservable();

  constructor(
    private msalService: MsalService
  ) {
  }

  assignUserInfo(userInfo: UserInfo) {
    this.rolesSource.next(userInfo);
  }

  getActiveAccount() {
    return this.msalService.instance.getActiveAccount();
  }

  logout() {
    sessionStorage.removeItem('redirectUrl');
    this.rolesSource.next(null);
    return this.msalService.logoutRedirect();
  }

  logoutAndRelogin(): void {
    this.clearMsalInteractionLocks();
    sessionStorage.removeItem('redirectUrl');
    this.rolesSource.next(null);

    const activeAccount = this.msalService.instance.getActiveAccount()
      ?? this.msalService.instance.getAllAccounts()[0]
      ?? null;

    if (activeAccount) {
      void this.msalService.instance.logoutRedirect().catch((error: any) => {
        if (error?.errorCode !== 'interaction_in_progress') {
          console.error('MSAL logoutRedirect failed:', error);
        }
      });
      return;
    }

    void this.msalService.instance.loginRedirect({scopes: ['openid', 'profile']}).catch((error: any) => {
      if (error?.errorCode !== 'interaction_in_progress') {
        console.error('MSAL loginRedirect failed:', error);
      }
    });
  }

  private clearMsalInteractionLocks(): void {
    Object.keys(sessionStorage)
      .filter(k => k.endsWith('.interaction.status'))
      .forEach(k => sessionStorage.removeItem(k));
  }

  roles = ['GPL'
    , 'ST_TL_Steering'
    , 'ST_Projectsteerer'
    , 'EN_TL_Engineering'
    , 'AX Administrator'
    , 'AX Management'
    , 'AX Project Coordination'
    , 'EX Administrator'
    , 'EX Management'
    , 'EX_Project Coordination'
    , 'Quality Controller'
    , 'Construction Manager'
    , 'Acquirer'
    , 'Designer'
    , 'Specifier'
    , 'Project Manager'];
}
